<template>
    <div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div id="personalTodos" class="todo-category accordion-item">
                <div class="accordion-header-container">
                    <div class="accordion-header">
                        <button class="accordion-button collapsed" type="button"
                            data-bs-toggle="collapse" data-bs-target="#personalTodo"
                            aria-expanded="true" aria-controls="personalTodo">
                            <span class="round-icon bg-lightblue text-white me-3">
                                <i class="fa fa-list-ul"></i>
                            </span>
                            <span class="title">Eigen todo's</span>
                            <span class="ms-auto badge amount rounded-pill text-bg-primary">
                                {{ this.count }}
                            </span>
                        </button>
                    </div>
                </div>
                <div id="personalTodo" class="accordion-collapse collapse show"
                     data-bs-parent="#todos">
                    <div class="accordion-body">

                        <div v-if="showCreateForm">
                            <form id="newField" class="todo">
                                <input type="hidden" v-model="form.id">
                                <div class="todo-data">
                                    <div class="description">
                                        <input v-model="form.description" type="text" class="form-control" placeholder="Omschrijving">
                                    </div>
                                    <div class="date ms-sm-auto">
                                        <input v-model="form.due_date" type="date" class="text-lightgrey"/>
                                    </div>
                                </div>
                                <div class="actions ms-auto">
                                    <div class="round-btn success bg-lightgreen" role="button" @click="update()">
                                        <i class="fa fa-check text-success icon-small"></i>
                                    </div>
                                    <div class="round-btn danger bg-light-red" role="button" @click="hideCreateForm()">
                                        <i class="fa fa-times text-danger icon-small"></i>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div v-for="item in todos">

                            <!-- Update form -->
                            <div v-if="item.showForm" class="todo">
                                <input type="hidden" v-model="item.id">
                                <div class="todo-data">
                                    <div class="description">
                                        <p class="mb-0">
                                            <input v-model="item.description" type="text" class="form-control" placeholder="Omschrijving">
                                        </p>
                                    </div>
                                    <div class="date ms-sm-auto">
                                        <input v-model="item.due_date" type="date" class="text-lightgrey">
                                    </div>
                                </div>
                                <div class="actions ms-auto">
                                    <div class="round-btn success bg-lightgreen" role="button" @click="update(item)">
                                        <i class="fa fa-check text-success icon-small"></i>
                                    </div>
                                    <div class="round-btn danger bg-light-red" role="button" @click="item.showForm = false">
                                        <i class="fa fa-times text-danger icon-small"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- List items -->
                            <div v-else class="todo">
                                <span v-if="item.is_overdue" class="warning success bg-light-red">
                                    <i class="fa fa-exclamation text-danger icon-small"></i>
                                </span>
                                <input type="hidden" v-model="item.id">
                                <div class="todo-data">
                                    <div class="description">
                                        {{ item.description }}
                                    </div>
                                    <div class="date ms-sm-auto">
                                        {{ item.due_date_formatted }}
                                    </div>
                                </div>
                                <div class="actions ms-auto">
                                    <i class="fa fa-pencil-square-o text-lightgrey" role="button" @click="item.showForm = true"></i>
                                    <i class="fa fa-trash-o text-lightgrey" role="button" @click="hideItem(item)"></i>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

    export default {
        name: 'my-todos',
        components: {},
        props: {
            showCreateForm: Boolean,
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                todos: [{
                    key: {
                        id: '',
                        description: '',
                        due_date: '',
                        due_date_formatted: '',
                        is_overdue: false,
                        showForm: false,
                    }
                }],
                count: 0,
                form: {
                    id: null,
                    description: '',
                    due_date: '',
                    is_done: '',
                },
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            getTodoUser() {
                axios.get('api/todo-user')
                    .then(response => {
                        if (response.data.status === 422) {
                            throw [true, response.data.message];
                        }

                        this.todos = response.data.todos;
                        this.count = response.data.count;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
            update(item) {
                let id = null;
                let description = null;
                let due_date = null;

                if (item) {
                    id = item.id;
                    description = item.description;
                    due_date = item.due_date;

                } else {
                    description = this.form.description;
                    due_date = this.form.due_date;
                }

                axios.post('api/todo-user-update', {
                    id: id,
                    description: description,
                    due_date: due_date,
                })
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    this.hideCreateForm();
                    this.getTodoUser();
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
                });
            },
            hideItem(item) {
                let parent = this;

                this.$swal({
                    title: "Weet je het zeker?",
                    text: "Deze actie kan niet ongedaan gemaakt worden.",
                    showCancelButton: true,
                    cancelButtonColor: "#3EBE00",
                    confirmButtonColor: "#DD3444",
                    confirmButtonText: "Ja, nu verwijderen",
                    cancelButtonText: "Annuleren",
                }).then(

                    function (callBack) {
                        if (callBack.isConfirmed) {
                            axios.post('api/todo-user-update', {
                                id: item.id,
                                is_done: 1,
                            })
                            .then(response => {
                                if (response.data.status === 422) {
                                    throw [true, response.data.message];
                                }

                                parent.getTodoUser();
                            })
                            .catch(e => {
                                parent.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
                            });
                        }
                    }
                );
            },
            hideCreateForm() {
                this.form.description = '';
                this.form.due_date = '';
                this.$emit('hideForm');
            },
        },
        mounted() {
            this.getTodoUser();
        },
        created() {},
    }
</script>
